module.exports = __webpack_public_path__ + "img/lyggz.54919845.png";